import { fetchPricingPlanMap, fetchPricingPlanList, fetchPriceFromZuora } from '@/apis';

let pricingMapCache = null

export function getPricingMap() {
  if (pricingMapCache) {
    return Promise.resolve(pricingMapCache)
  } else {
    return new Promise((resolve) => {
      fetchPricingPlanMap().then(data => {
        pricingMapCache = data
        resolve(data)
      })
    })
  }
}

export async function getProNode() {
  const priceMap = await getPricingMap()
  return priceMap.pro || {}
}

export const cachePromise = (func, config = { isPersisted: true }) => {
  let m = new Map();
  return async function (...args) {
    const params = args.map(a => a instanceof FormData ? Object.fromEntries(a) : a);
    const key = JSON.stringify(params);

    if (!m.has(key)) {
      const p = async () => {
        const res = await func(...args);
        if (!config.isPersisted) {
          m.delete(key);
        }
        return res;
      }
      m.set(key, p());
    }
    return m.get(key);
  }
}

export const getAllPlanPrice$Cache = cachePromise(async () => {
  const res = await fetchPriceFromZuora()
  return res
})

export const getBasePlan$Cache = cachePromise(async () => {
  const res = await fetchPricingPlanList()
  return res.productList[0]
})
